module.exports = __webpack_public_path__ + "img/logo2.8e76f6dc.png";